
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { 
  FileText, 
  BookmarkPlus, 
  Shield, 
  Gavel, 
  MessageCircle, 
  PenTool, 
  BookOpen, 
  Search, 
  Book, 
  Scroll
} from 'lucide-react';

const navigationItems = [
  { id: 'all', label: 'All', icon: FileText },
  { id: 'theology_answers', label: 'Theology Answers', icon: BookmarkPlus },
  { id: 'atheism_defense', label: 'Atheism Defense', icon: Shield },
  { id: 'moral_dilemmas', label: 'Moral Dilemmas', icon: Gavel },
  { id: 'interfaith_dialogue', label: 'Interfaith Dialogue', icon: MessageCircle },
  { id: 'prayer', label: 'Prayer', icon: PenTool },
  { id: 'reading_plan', label: 'Reading Plans', icon: BookOpen },
  { id: 'find_your_verse', label: 'Find Your Verse', icon: Search },
  { id: 'deep_dive', label: 'Deep Dive', icon: Book },
  { id: 'etymology', label: 'Etymology', icon: Scroll },
  { id: 'scripture_navigator', label: 'Scripture Navigator', icon: BookOpen },
];

interface DashboardNavigationProps {
  activeTab: string;
  onTabChange: (value: string) => void;
}

export const DashboardNavigation: React.FC<DashboardNavigationProps> = ({
  activeTab,
  onTabChange
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="w-full mb-6">
        <Select value={activeTab} onValueChange={onTabChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select category" />
          </SelectTrigger>
          <SelectContent>
            {navigationItems.map(({ id, label, icon: Icon }) => (
              <SelectItem key={id} value={id}>
                <div className="flex items-center gap-2">
                  <Icon className="h-4 w-4" />
                  <span>{label}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }

  return (
    <Tabs value={activeTab} onValueChange={onTabChange}>
      <TabsList className="flex flex-wrap justify-start gap-2 pb-2 mb-6">
        {navigationItems.map(({ id, label, icon: Icon }) => (
          <TabsTrigger key={id} value={id} className="flex items-center gap-2 whitespace-nowrap">
            <Icon className="h-4 w-4" />
            <span>{label}</span>
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
